// extracted by mini-css-extract-plugin
module.exports = {"productPage":"ProductPage_productPage__4Ne61","content":"ProductPage_content___9_di"};